export default __webpack_public_path__ + "static/media/google-cloud.bbaa92f1.svg";